// Open-Bust Tummy Control Faja — second product
// Pricing matches main brand strategy: 25% off retail
export const openBustProductData = {
  id: "open-bust-faja",
  name: "Open-Bust Tummy Control Faja",
  tagline: "Snatched. Smooth. Unbothered.",
  description: `You're not just getting dressed — you're getting ready to turn heads.

The Faja Colombiana Open-Bust Tummy Control Bodysuit is the secret weapon living under every killer outfit. While everyone's asking "how does she look like that?" — you'll already know.

Colombian compression that grips, smooths, and sculpts your midsection from every angle so your clothes fall exactly the way they're supposed to. No lumps. No shifting. No adjusting every five minutes. Just a silhouette that looks like you woke up like this.

Wear your own bra. Style your own straps. Hook in, walk out, and own every room you walk into.

Confidence isn't an accessory. But this comes close.`,
  price: 39.99,
  originalPrice: 59.99,
  rating: 4.9,
  reviewCount: 1247,
  sizes: ["S/M", "L/XL", "1XL/2XL", "3XL/4XL"],
  colors: ["Black", "Nude"],
  imagesByColor: {
    Black: [
      "https://curvluxe.com/cdn/shop/files/fajas-colombianas-tummy-control-shapewear-bodysuit-for-wedding-or-prom-9381302.jpg",
      "https://curvluxe.com/cdn/shop/files/fajas-colombianas-tummy-control-shapewear-bodysuit-for-wedding-or-prom-5185141.jpg?v=1779943091",
      "https://curvluxe.com/cdn/shop/files/fajas-colombianas-tummy-control-shapewear-bodysuit-for-wedding-or-prom-2460581.jpg?v=1779943091",
      "https://curvluxe.com/cdn/shop/files/fajas-colombianas-tummy-control-shapewear-bodysuit-for-wedding-or-prom-6822863.jpg?v=1779943090",
      "https://curvluxe.com/cdn/shop/files/fajas-colombianas-tummy-control-shapewear-bodysuit-for-wedding-or-prom-9294780.jpg?v=1779943090"
    ],
    Nude: [
      "https://curvluxe.com/cdn/shop/files/fajas-colombianas-tummy-control-shapewear-bodysuit-for-wedding-or-prom-9381302.jpg",
      "https://customer-assets.emergentagent.com/job_item-landing/artifacts/02ptojhv_Hook%20and%20eye.jpeg",
      "https://customer-assets.emergentagent.com/job_item-landing/artifacts/ti15dprt_Close%20up%20beige.jpg"
    ]
  },
  features: [
    { title: "Authentic Colombian Compression", description: "Sculpts and smooths for a real hourglass — no lumps, no shifting, no adjusting." },
    { title: "Open-Bust Design", description: "Wear it with any bra, your rules — strapless, bralette, push-up, or your everyday favorite." },
    { title: "Adjustable & Removable Straps", description: "Made for your body. Wear with straps, strapless, or fully open-bust." },
    { title: "Front Hook-and-Eye Closure", description: "Easy on, easy off. Three rows of front hooks — you control the fit and the snatch." },
    { title: "Delicate Lace Trim", description: "Because feeling sexy matters too. Soft, feminine finish at the bust line." },
    { title: "Breathable Polyamide", description: "Comfort that lasts all day and all night — built for real wear, not just photos." }
  ]
};

// Standalone Seamless Boyshorts product
export const boyshortsProductData = {
  id: "boyshorts",
  name: "Seamless Second-Skin Smoothing Boyshorts",
  subtitle: "Soft, invisible everyday smoothing — the easiest first step into shapewear.",
  tagline: "Second-skin smoothing under everything you already love.",
  price: 28.99,
  rating: 4.9,
  reviewCount: 412,
  sizes: ["S/M", "L/XL", "1XL/2XL", "3XL/4XL"],
  colors: ["Black", "Nude"],
  images: [
    "https://customer-assets.emergentagent.com/job_item-landing/artifacts/a4jwqjk2_image.png"
  ],
  description: "Soft, invisible second-skin coverage. Smooths and shapes under any outfit. The easiest first step into shapewear — zero learning curve."
};

// Bundle: Both products together — buy 2 fajas, get high-quality boyshorts FREE
export const bundleData = {
  id: "bundle",
  name: "The Snatched Duo + Free Boyshorts",
  subtitle: "Full Body Faja Colombiana + Open-Bust Tummy Control Faja",
  tagline: "Get snatched from bust to thigh — buy any 2 fajas, get our seamless boyshorts free.",
  description: `Get both fajas and we'll throw in our high-quality Seamless Second-Skin Smoothing Boyshorts — completely free.

The Full Body Faja Colombiana — your daily, all-occasion sculptor with built-in bra.

The Open-Bust Tummy Control Faja — for strapless dresses, weddings, special bras, and anything that needs your own bra underneath.

The Seamless Second-Skin Smoothing Boyshorts — soft, invisible, second-skin coverage for everything in between. Yours free with this bundle.`,
  // Both fajas at full price; high-quality boyshorts included free as a gift
  individualTotal: 89.99, // 2 fajas
  price: 89.99,
  rating: 4.9,
  reviewCount: 1247,
  sizes: ["S/M", "L/XL", "1XL/2XL", "3XL/4XL"],
  colors: ["Black", "Nude"],
  images: [
    "https://customer-assets.emergentagent.com/job_item-landing/artifacts/ymvx3tpt_openart-14c4bd9b-a791-48cc-996b-d64c115a23b4.png",
    "https://curvluxe.com/cdn/shop/files/fajas-colombianas-tummy-control-shapewear-bodysuit-for-wedding-or-prom-9381302.jpg"
  ],
  freeGift: {
    name: "Seamless Second-Skin Smoothing Boyshorts",
    image: "https://customer-assets.emergentagent.com/job_item-landing/artifacts/a4jwqjk2_image.png",
    description: "High-quality, soft, invisible second-skin coverage. Smooths and shapes under any outfit."
  }
};
